module.exports = __webpack_public_path__ + "img/zz_01.3d0b5881.jpg";